module.exports = __webpack_public_path__ + "img/29.d41f57c4.png";